import api from '@/api/boxes';
import store from '@/store';
import * as types from './types';

export default {
  resetResult(context) {
    context.commit(types.SET_RESULT, []);
  },
  getMatchesBoxes(context, params) {
    return api.search(params).then((response) => {
      if (response.status === 'success') {
        const data = response.content;
        context.commit(types.SET_RESULT, data);
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      context.commit(types.SET_RESULT, []);
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Recommencez', type: 'error' });
      return Promise.reject(err);
    });
  },
  deleteDuplicateBoxe(context, params) {
    return api.deleteBoxe(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Le coffre est bien supprimé', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  deleteRGPDBoxe(context, params) {
    return api.deleteRGPDBoxe(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Le coffre est bien supprimé en application de la RGPD', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  updateEmailBoxe(context, params) {
    return api.updateEmailBoxe(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Le champ Email du coffre a été mis à jour', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  updateLoginBoxe(context, params) {
    return api.updateLoginBoxe(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Le champ Login du coffre a été mis à jour', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  updateSecretQuestionBoxe(context, params) {
    return api.updateSecretQuestionBoxe(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Le champ Question secrète du coffre a été mis à jour', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  updateGender(context, params) {
    return api.updateGenderBoxe(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Le champ Genre du coffre a été mis à jour', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  updateDematStatus(context, params) {
    return api.updateDematStatus(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Le champ Status de dématérialisation a été mis à jour', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  updateFirstnameLastname(context, params) {
    return api.updateFirstnameLastname(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Les champs Prénom et Nom ont été mis à jour', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  addEfoliaIdBoxe(context, params) {
    return api.addEfoliaId(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'L\'efoliaId a été ajouté', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
  unlockBoxe(context, params) {
    return api.unlockBoxe(params).then((response) => {
      if (response.status === 'success') {
        store.dispatch('application/pushAlert', { message: 'Le coffre a été déverrouillé', type: 'success' });
        return Promise.resolve(response);
      }
      return Promise.reject(response);
    }).catch((err) => {
      store.dispatch('application/pushAlert', { message: 'Une erreur s\'est produite. Veuillez recommencer', type: 'error' });
      return Promise.reject(err);
    });
  },
};
